(function(angular) {
    'use strict';
    class TemplateWarning {
        constructor($translate, $mdDialog) {
            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
        }

        $onInit() {
            this.getModalText();
            this.okText = this.$translate.instant('Ok');
        }

        getModalText() {
            this.showCheckbox = true;
            let modalHeaderKey = 'icm-outreach__template-limits--near-limit-header';
            let modalBodyKey = 'icm-outreach__template-limits--near-limit-body';
            if (this.templateCount === 50) {
                this.showCheckbox = false;
                modalHeaderKey = 'icm-outreach__template-limits--limit-reached-header';
                modalBodyKey = 'icm-outreach__template-limits--limit-reached-body';
            }

            this.checkboxLabel = this.$translate.instant('icm-outreach__template-limits--stop-notification-checkbox-label');
            this.modalTitle = this.$translate.instant(modalHeaderKey, {templateCount: this.templateCount});
            this.modalBody = this.$translate.instant(modalBodyKey, {templateCount: this.templateCount});
        }
        
        handleOk() {
            this.$mdDialog.hide({stopNotification: this.stopNotification});
        }
    }

    angular.module('MW.ContactManager.TemplateWarning', [
        'ngMaterial'
    ])
    .component('templateWarning', {
        bindings: {
            stopNotification: '<',
            templateCount: '<'
        },
        controller: ['$translate', '$mdDialog', TemplateWarning],
        template: `
        <mw-mini-modal-dialog id="template-warning-mini-modal" layout="column" data="$ctrl.stopNotification" dialog-title="{{$ctrl.modalTitle}}" ok="{{$ctrl.okText}}" cancel="" on-ok="$ctrl.handleOk($event)">
            <mw-modal-content>
                <div layout="column">
                    <p>
                        {{$ctrl.modalBody}}
                    </p>
                    <md-checkbox ng-if="$ctrl.showCheckbox" class="md-primary body" ng-model="$ctrl.stopNotification" aria-label="$ctrl.checkboxLabel">
                        <span ng-bind-html="$ctrl.checkboxLabel"></span>
                    </md-checkbox>
                </div>
            </mw-modal-content>
        </mw-mini-modal-dialog>
        `
    });
})(window.angular);